<template>
  <section class="h-auto bg-black">
    <div class="px-8 py-14 lg:py-24">
      <div class="flex flex-row items-center justify-center">
        <img
          v-motion-pop-visible
          src="../assets/prev-lead-title.png"
          class="max-h-[100px] lg:max-h-[120px] xl:max-h-[150px] h-full w-auto"
          alt="prev-leaderboard"
        />
      </div>
      <div
        v-if="prevloading == true"
        class="mt-10 text-2xl font-bold text-center text-white md:text-4xl"
        style="font-family: Russo One, sans-serif"
      >
        Waiting for Reset...
      </div>
      <div
        v-if="prevloading == true"
        class="mt-10 text-2xl font-bold text-center text-white md:text-4xl"
        style="font-family: Russo One, sans-serif"
      >
        Loading Previous Leaderboard...
      </div>
      <div v-if="prevloading == false" class="flex items-center justify-center">
        <div class="block mt-6">
          <div class="relative flex items-center rounded-full bg-[#440101]">
            <!-- Slider Background -->
            <div
              class="absolute top-0 h-full rounded-full bg-gradient-to-r from-[#050505] via-[#5C2027] to-[#8B1259] transition-all duration-300 z-1"
              :style="{
                width: '50%',
                left: selectedPrevLeaderboard === 'stake' ? '0%' : '50%',
              }"
            ></div>

            <!-- STAKE -->
            <button
              class="flex-1 px-2 py-3 md:p-5 text-white text-[7px] md:text-[14px] font-bold transition-all duration-300 z-20"
              @click="selectedPrevLeaderboard = 'stake'"
              style="font-family: Stalinist One, sans-serif"
            >
              STAKE
            </button>

            <!-- STAKE ENGINE -->
            <button
              class="flex-1 px-2 py-3 md:p-5 text-white text-[7px] md:text-[14px] font-bold transition-all duration-300 z-20"
              @click="selectedPrevLeaderboard = 'stakeonly'"
              style="font-family: Stalinist One, sans-serif"
            >
              STAKE ENGINE
            </button>

            <!-- SHUFFLE (COMMENTED OUT - REPLACED BY STAKE) -->
            <!-- <button
              class="flex-1 px-2 py-3 md:p-5 text-white text-[7px] md:text-[14px] font-bold transition-all duration-300 z-20"
              @click="selectedPrevLeaderboard = 'shuffle'"
              style="font-family: Stalinist One, sans-serif"
            >
              SHUFFLE
            </button> -->

            <!-- SKINRAVE (COMMENTED OUT - HIDDEN FOR NOW) -->
            <!-- <button
              class="flex-1 px-2 py-3 md:p-5 text-white text-[7px] md:text-[14px] font-bold transition-all duration-300 z-20"
              @click="selectedPrevLeaderboard = 'skinrave'"
              style="font-family: Stalinist One, sans-serif"
            >
              SKINRAVE
            </button> -->

            <!-- CASEBATTLE (COMMENTED OUT - HIDDEN FOR NOW) -->
            <!-- <button
              class="flex-1 px-2 py-3 md:p-5 text-white text-[7px] md:text-[14px] font-bold transition-all duration-300 z-20"
              @click="selectedPrevLeaderboard = 'casebattle'"
              style="font-family: Stalinist One, sans-serif"
            >
              CASEBATTLE
            </button> -->

            <!-- PACKDRAW (COMMENTED OUT - HIDDEN FOR NOW) -->
            <!-- <button
              class="flex-1 px-2 py-3 md:p-5 text-white text-[7px] md:text-[14px] font-bold transition-all duration-300 z-20"
              @click="selectedPrevLeaderboard = 'packdraw'"
              style="font-family: Stalinist One, sans-serif"
            >
              PACKDRAW
            </button> -->

            <!-- CSDROP (COMMENTED OUT - HIDDEN FOR NOW) -->
            <!-- <button
              class="flex-1 px-2 py-3 md:p-5 text-white text-[7px] md:text-[14px] font-bold transition-all duration-300 z-20"
              @click="selectedPrevLeaderboard = 'csdrop'"
              style="font-family: Stalinist One, sans-serif"
            >
              CSDROP
            </button> -->

            <!-- EMPIREDROP (COMMENTED OUT - HIDDEN FOR NOW) -->
            <!-- <button
              class="flex-1 px-2 py-3 md:p-5 text-white text-[7px] md:text-[14px] font-bold transition-all duration-300 z-20"
              @click="selectedPrevLeaderboard = 'empiredrop'"
              style="font-family: Stalinist One, sans-serif"
            >
              EMPIREDROP
            </button> -->

            <!-- RAIN.GG (COMMENTED OUT FOR FUTURE USE) -->
            <!-- <button
              class="flex-1 px-2 py-3 md:p-5 text-white text-[7px] md:text-[14px] font-bold transition-all duration-300 z-20"
              @click="selectedPrevLeaderboard = 'raingg'"
              style="font-family: Stalinist One, sans-serif"
            >
              RAIN.GG
            </button> -->

            <!-- CSGOLD (COMMENTED OUT PER CLIENT REQUEST) -->
            <!-- <button
              class="flex-1 px-2 py-3 md:p-5 text-white text-[7px] md:text-[14px] font-bold transition-all duration-300 z-20"
              @click="selectedPrevLeaderboard = 'csgold'"
              style="font-family: Stalinist One, sans-serif"
            >
              CSGOLD
            </button> -->
          </div>
        </div>
      </div>

      <div v-if="prevloading == false" class="hidden md:block">
        <div
          class="flex justify-center mt-8 mb:mb-24"
          style="font-family: Russo One, sans-serif"
        >
          <table class="w-full border-separate lg:w-auto border-spacing-y-6">
            <thead
              v-motion-slide-visible-bottom
              class="rounded-2xl bg-gradient-to-r from-[#840000] via-[#350003] to-[#57003F]"
            >
              <tr>
                <th
                  class="px-1 md:px-[45px] lg:pr-24 lg:pl-8 py-2 md:py-4 text-white text-[18px] md:text-xl font-thin text-left rounded-l-full"
                >
                  Ranks
                </th>
                <th
                  class="px-1 md:px-[45px] lg:px-24 py-2 md:py-4 text-white text-[18px] md:text-xl font-thin text-center"
                >
                  User
                </th>
                <th
                  class="px-1 md:px-[45px] lg:px-24 py-2 md:py-4 text-white text-[18px] md:text-xl font-thin text-center"
                >
                  Amount
                </th>
                <th
                  class="px-1 md:px-[45px] lg:pl-24 lg:pr-8 py-2 md:py-4 text-white text-[18px] md:text-xl font-thin text-right rounded-r-full"
                >
                  Prize
                </th>
              </tr>
            </thead>
            <tbody class="mt-4">
              <tr v-if="displayedPrevLead.length === 0">
                <td
                  colspan="4"
                  class="py-10 text-center text-white text-[16px] font-normal opacity-60"
                  style="font-family: 'Russo One', sans-serif"
                >
                  No previous leaderboard data available yet.
                </td>
              </tr>
              <tr
                v-motion-slide-visible-bottom
                v-for="(item, index) in displayedPrevLead"
                :key="index"
                class="bg-gradient-to-r from-[#840000] via-[#350003] to-[#57003F]"
              >
                <td
                  class="px-1 md:px-[45px] lg:px-10 py-2 md:py-4 whitespace-nowrap text-[18px] font-semibold text-left"
                >
                  <div class="flex flex-row items-center gap-2">
                    <div class="text-white">
                      {{ getOrdinalSuffix(index + 1) }}
                    </div>
                  </div>
                </td>
                <td
                  class="px-1 md:px-[45px] lg:px-24 py-2 md:py-5 whitespace-nowrap text-[18px] text-white font-thin text-center"
                >
                  {{
                    isStakePrevLeaderboard
                      ? item.username
                      : maskString(
                      selectedPrevLeaderboard === "casebattle"
                        ? item.user?.username
                        : item.username,
                    )
                  }}
                </td>
                <td
                  class="px-1 md:px-[45px] lg:px-24 py-2 md:py-5 whitespace-nowrap text-[18px] text-white font-thin text-center"
                >
                  <template v-if="selectedPrevLeaderboard === 'shuffle'">
                    <div class="flex flex-col items-center leading-snug">
                      <span>${{ parseFloat(item?.wagerAmount || 0).toFixed(2) }}</span>
                      <span class="text-[13px] text-gray-300 whitespace-nowrap">${{ parseFloat(item?.weightedWagerAmount || 0).toFixed(2) }} weighted</span>
                    </div>
                  </template>
                  <template v-else-if="isStakePrevLeaderboard">
                    <div class="flex flex-col items-center leading-snug">
                      <span>${{ parseFloat(item?.wageredAmount || 0).toFixed(2) }}</span>
                      <span v-if="selectedPrevLeaderboard === 'stake'" class="text-[13px] text-gray-300 whitespace-nowrap">${{ parseFloat(item?.weightedWageredAmount || 0).toFixed(2) }} weighted</span>
                    </div>
                  </template>
                  <template v-else>
                    {{
                      selectedPrevLeaderboard === "casebattle"
                        ? `$${parseFloat(item?.amount || 0).toFixed(2).toLocaleString()}`
                        : item.amount
                    }}
                  </template>
                </td>
                <td
                  class="px-1 md:px-[45px] lg:px-8 py-2 md:py-5 whitespace-nowrap text-[18px] text-white font-thin text-right"
                >
                  {{ getRewardValue(index) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="prevloading == false" class="block md:hidden">
        <div
          class="flex justify-center mt-8 text-xl mb:mb-24"
          style="font-family: Russo One, sans-serif"
        >
          <table class="w-full lg:w-auto">
            <thead v-motion-slide-visible-bottom>
              <tr>
                <th
                  class="md:px-[85px] lg:px-28 py-2 md:py-10 text-white text-[14px] md:text-2xl font-bold text-left"
                >
                  Ranks
                </th>
                <th
                  class="md:px-[85px] lg:px-28 py-2 md:py-10 text-white text-[14px] md:text-2xl font-bold text-center"
                >
                  User
                </th>
                <th
                  class="md:px-[85px] lg:px-28 py-2 md:py-10 text-white text-[14px] md:text-2xl font-bold text-center"
                >
                  Amount
                </th>
                <th
                  class="md:px-[85px] lg:px-28 py-2 md:py-10 text-white text-[14px] md:text-2xl font-bold text-right"
                >
                  Prize
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="displayedPrevLead.length === 0">
                <td
                  colspan="4"
                  class="py-8 text-center text-white text-[13px] font-normal opacity-60"
                  style="font-family: 'Russo One', sans-serif"
                >
                  No previous leaderboard data available yet.
                </td>
              </tr>
              <tr
                v-motion-slide-visible-bottom
                v-for="(item, index) in displayedPrevLead"
                :key="index"
              >
                <td
                  class="px-1 md:px-[85px] lg:px-28 py-2 md:py-5 whitespace-nowrap text-[14px] text-white font-normal text-left"
                >
                  {{ getOrdinalSuffix(index + 1) }}
                </td>
                <td
                  class="px-1 md:px-[85px] lg:px-28 py-2 md:py-5 whitespace-nowrap text-[14px] text-white font-normal text-center"
                >
                  {{
                    isStakePrevLeaderboard
                      ? item.username
                      : maskString(
                      selectedPrevLeaderboard === "casebattle"
                        ? item.user?.username
                        : item.username,
                    )
                  }}
                </td>
                <td
                  class="px-1 md:px-[85px] lg:px-28 py-2 md:py-5 whitespace-nowrap text-[14px] text-white font-normal text-center"
                >
                  <template v-if="selectedPrevLeaderboard === 'shuffle'">
                    <div class="flex flex-col items-center leading-snug">
                      <span>${{ parseFloat(item?.wagerAmount || 0).toFixed(2) }}</span>
                      <span class="text-[11px] text-gray-300 whitespace-nowrap">${{ parseFloat(item?.weightedWagerAmount || 0).toFixed(2) }} weighted</span>
                    </div>
                  </template>
                  <template v-else-if="isStakePrevLeaderboard">
                    <div class="flex flex-col items-center leading-snug">
                      <span>${{ parseFloat(item?.wageredAmount || 0).toFixed(2) }}</span>
                      <span v-if="selectedPrevLeaderboard === 'stake'" class="text-[11px] text-gray-300 whitespace-nowrap">${{ parseFloat(item?.weightedWageredAmount || 0).toFixed(2) }} weighted</span>
                    </div>
                  </template>
                  <template v-else>
                    {{
                      selectedPrevLeaderboard === "casebattle"
                        ? `$${parseFloat(item?.amount || 0).toFixed(2).toLocaleString()}`
                        : item.amount
                    }}
                  </template>
                </td>
                <td
                  class="px-1 md:px-[85px] lg:px-28 py-2 md:py-5 whitespace-nowrap text-[14px] text-white font-normal text-right"
                >
                  {{ getRewardValue(index) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      displayedPrevLead: [],
      stakePrevLeaderboard: [],
      stakeonlyPrevLeaderboard: [],
      shufflePrevLeaderboard: [],
      skinravePrevLeaderboard: [],
      casebattlePrevLeaderboard: [],
      // packdrawPrevLeaderboard: [],
      // csdropPrevLeaderboard: [],
      // empiredropPrevLeaderboard: [],
      // rainggPrevLeaderboard: [],
      // csgoldPrevLeaderboard: [],
      prevloading: false,
      currentPrevLeaderboardCount: 8,

      selectedPrevLeaderboard: "stake",
    };
  },
  computed: {
    isStakePrevLeaderboard() {
      return ["stake", "stakeonly"].includes(this.selectedPrevLeaderboard);
    },
  },
  methods: {
    init() {
      this.initPrevLeaderboard();
    },

    async initPrevLeaderboard() {
      try {
        const baseUrl = process.env.VUE_APP_BASE_API;
        this.prevLoading = true;

        // Fetch Stake previous leaderboard
        const stakeRes = await axios.get(
          `${baseUrl}/api/leaderboard/stake?previous=true`,
          {
            headers: { "x-api-key": process.env.VUE_APP_X_API_KEY },
          },
        );
        this.stakePrevLeaderboard = stakeRes.data.leaderboard;

        // Fetch Stake Engine previous leaderboard
        const stakeonlyRes = await axios.get(
          `${baseUrl}/api/leaderboard/stakeonly?previous=true`,
          {
            headers: { "x-api-key": process.env.VUE_APP_X_API_KEY },
          },
        );
        this.stakeonlyPrevLeaderboard = stakeonlyRes.data.leaderboard;

        // Fetch Shuffle previous leaderboard (COMMENTED OUT - REPLACED BY STAKE)
        // const shuffleRes = await axios.get(
        //   `${baseUrl}/api/leaderboard/shuffle?previous=true`,
        //   {
        //     headers: { "x-api-key": process.env.VUE_APP_X_API_KEY },
        //   },
        // );
        // this.shufflePrevLeaderboard = shuffleRes.data.leaderboard;

        // Fetch Skinrave previous leaderboard (NO PREVIOUS LEADERBOARD YET)
        // const skinraveRes = await axios.get(
        //   `${baseUrl}/api/leaderboard/skinrave?previous=true`,
        //   {
        //     headers: { "x-api-key": process.env.VUE_APP_X_API_KEY },
        //   },
        // );
        // this.skinravePrevLeaderboard = skinraveRes.data.leaderboard;
        this.skinravePrevLeaderboard = [];

        // Fetch Casebattle previous leaderboard
        const casebattleRes = await axios.get(
          `${baseUrl}/api/leaderboard/casebattle?previous=true`,
          {
            headers: { "x-api-key": process.env.VUE_APP_X_API_KEY },
          },
        );
        this.casebattlePrevLeaderboard = casebattleRes.data.leaderboard;

        // Fetch Packdraw previous leaderboard (COMMENTED OUT - HIDDEN FOR NOW)
        // const packdrawRes = await axios.get(
        //   `${baseUrl}/api/leaderboard/packdraw?previous=true`,
        //   {
        //     headers: { "x-api-key": process.env.VUE_APP_X_API_KEY },
        //   },
        // );
        // this.packdrawPrevLeaderboard = packdrawRes.data.leaderboard;

        // Fetch CSDROP previous leaderboard (COMMENTED OUT - NO PREVIOUS LEADERBOARD YET)
        // const csdropRes = await axios.get(
        //   `${baseUrl}/api/leaderboard/csdrop?previous=true`,
        //   {
        //     headers: { "x-api-key": process.env.VUE_APP_X_API_KEY },
        //   }
        // );
        // this.csdropPrevLeaderboard = csdropRes.data.leaderboard;

        // Fetch EMPIREDROP previous leaderboard (COMMENTED OUT - NO PREVIOUS LEADERBOARD YET)
        // const empiredropRes = await axios.get(
        //   `${baseUrl}/api/leaderboard/empiredrop?previous=true`,
        //   {
        //     headers: { "x-api-key": process.env.VUE_APP_X_API_KEY },
        //   }
        // );
        // this.empiredropPrevLeaderboard = empiredropRes.data.leaderboard;

        // Fetch Rain.gg previous leaderboard (SET TO EMPTY FOR NOW)
        // const rainggRes = await axios.get(
        //   `${baseUrl}/api/leaderboard/raingg?previous=true`,
        //   {
        //     headers: { "x-api-key": process.env.VUE_APP_X_API_KEY },
        //   }
        // );
        // this.rainggPrevLeaderboard = rainggRes.data.leaderboard;
        // this.rainggPrevLeaderboard = [];

        // Fetch Csgold previous leaderboard (COMMENTED OUT PER CLIENT REQUEST)
        // const csgoldRes = await axios.get(
        //   `${baseUrl}/api/leaderboard/csgold?previous=true`,
        //   {
        //     headers: { "x-api-key": process.env.VUE_APP_X_API_KEY },
        //   }
        // );
        // this.csgoldPrevLeaderboard = csgoldRes.data.leaderboard;
      } catch (error) {
        console.error("Error loading previous leaderboards:", error);
      } finally {
        this.prevLoading = false;
        this.changePrevLead();
      }
    },
    changePrevLead() {
      let prevLeaderboard = [];
      let prizes = [];

      switch (this.selectedPrevLeaderboard) {
        case "stake":
          prevLeaderboard = this.stakePrevLeaderboard;
          prizes = process.env.VUE_APP_STAKE_PRIZES_PREVIOUS
            ? JSON.parse(process.env.VUE_APP_STAKE_PRIZES_PREVIOUS)
            : [];
          break;
        case "stakeonly":
          prevLeaderboard = this.stakeonlyPrevLeaderboard;
          prizes = process.env.VUE_APP_STAKEONLY_PRIZES_PREVIOUS
            ? JSON.parse(process.env.VUE_APP_STAKEONLY_PRIZES_PREVIOUS)
            : [];
          break;
        case "shuffle":
          prevLeaderboard = this.shufflePrevLeaderboard;
          prizes = JSON.parse(
            `${process.env.VUE_APP_SHUFFLE_PRIZES_PREVIOUS}` || "[]",
          );
          break;
        case "skinrave":
          prevLeaderboard = this.skinravePrevLeaderboard;
          prizes = JSON.parse(
            `${process.env.VUE_APP_SKINRAVE_PRIZES_PREVIOUS}` || "[]",
          );
          break;
        case "casebattle":
          prevLeaderboard = this.casebattlePrevLeaderboard;
          prizes = JSON.parse(
            `${process.env.VUE_APP_CASEBATTLE_PRIZES_PREVIOUS}` || "[]",
          );
          break;
        // case "packdraw":
        //   prevLeaderboard = this.packdrawPrevLeaderboard;
        //   prizes = JSON.parse(
        //     `${process.env.VUE_APP_PACKDRAW_PRIZES_PREVIOUS}` || "[]",
        //   );
        //   break;
        // case "csdrop":
        //   prevLeaderboard = this.csdropPrevLeaderboard;
        //   prizes = JSON.parse(`${process.env.VUE_APP_CSDROP_PRIZES_PREVIOUS}` || "[]");
        //   break;
        // case "empiredrop":
        //   prevLeaderboard = this.empiredropPrevLeaderboard;
        //   prizes = JSON.parse(`${process.env.VUE_APP_EMPIREDROP_PRIZES_PREVIOUS}` || "[]");
        //   break;
        // case 'raingg':
        //   prevLeaderboard = this.rainggPrevLeaderboard;
        //   prizes = JSON.parse(`${process.env.VUE_APP_RAINGG_PRIZES_PREVIOUS}` || "[]");
        //   break;
        // case 'csgold':
        //   prevLeaderboard = this.csgoldPrevLeaderboard;
        //   prizes = JSON.parse(`${process.env.VUE_APP_CSGOLD_PRIZES_PREVIOUS}` || "[]");
        //   break;
      }

      this.currentPrevLeaderboardCount = prizes.length;
      this.displayedPrevLead = prevLeaderboard.slice(
        0,
        this.currentPrevLeaderboardCount,
      );
    },
    getOrdinalSuffix(n) {
      const s = ["th", "st", "nd", "rd"],
        v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    },

    getRewardValue(rank) {
      let currentPrizes = [];

      switch (this.selectedPrevLeaderboard) {
        case "stake":
          currentPrizes = process.env.VUE_APP_STAKE_PRIZES_PREVIOUS
            ? JSON.parse(process.env.VUE_APP_STAKE_PRIZES_PREVIOUS)
            : [];
          break;
        case "stakeonly":
          currentPrizes = process.env.VUE_APP_STAKEONLY_PRIZES_PREVIOUS
            ? JSON.parse(process.env.VUE_APP_STAKEONLY_PRIZES_PREVIOUS)
            : [];
          break;
        case "shuffle":
          currentPrizes = JSON.parse(
            `${process.env.VUE_APP_SHUFFLE_PRIZES_PREVIOUS}` || "[]",
          );
          break;
        case "skinrave":
          currentPrizes = JSON.parse(
            `${process.env.VUE_APP_SKINRAVE_PRIZES_PREVIOUS}` || "[]",
          );
          break;
        case "casebattle":
          currentPrizes = JSON.parse(
            `${process.env.VUE_APP_CASEBATTLE_PRIZES_PREVIOUS}` || "[]",
          );
          break;
        // case "packdraw":
        //   currentPrizes = JSON.parse(
        //     `${process.env.VUE_APP_PACKDRAW_PRIZES_PREVIOUS}` || "[]",
        //   );
        //   break;
        // case "csdrop":
        //   currentPrizes = JSON.parse(`${process.env.VUE_APP_CSDROP_PRIZES_PREVIOUS}` || "[]");
        //   break;
        // case "empiredrop":
        //   currentPrizes = JSON.parse(`${process.env.VUE_APP_EMPIREDROP_PRIZES_PREVIOUS}` || "[]");
        //   break;
        // case 'raingg':
        //   currentPrizes = JSON.parse(`${process.env.VUE_APP_RAINGG_PRIZES_PREVIOUS}` || "[]");
        //   break;
        // case 'csgold':
        //   currentPrizes = JSON.parse(`${process.env.VUE_APP_CSGOLD_PRIZES_PREVIOUS}` || "[]");
        //   break;
        default:
          currentPrizes = [];
      }

      if (rank >= currentPrizes.length) {
        return "$0";
      }
      return `$${currentPrizes[rank]}`;
    },

    maskString(str) {
      if (!str || str.length < 2) {
        return str;
      }
      if (!str || str.length <= 4) {
        const start = str.slice(0, 1);
        const end = str.slice(-1);
        const middleAsterisks = "*".repeat(str.length - 2);

        return `${start}${middleAsterisks}${end}`;
      } else {
        const start = str.slice(0, 2);
        const end = str.slice(-2);
        const middleAsterisks = "*".repeat(str.length - 4);

        return `${start}${middleAsterisks}${end}`;
      }
    },
  },
  watch: {
    selectedPrevLeaderboard() {
      this.changePrevLead(); // Automatically update displayed leaderboard
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.toggle-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 220px;
  height: 56px;
  background: linear-gradient(to right, #140000, #440000 34%);
  border-radius: 28px;
  padding: 0 8px;
  cursor: pointer;
}

.toggle-switch input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-switch .slider {
  position: absolute;
  left: 10px;
  height: 48px;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 24px;
  transition: transform 0.3s ease;
}

.toggle-switch input:checked + .slider {
  /* transform: translateX(180px); */
}

.toggle-switch span {
  color: white;
  font-size: 15px;
  font-weight: bold;
  z-index: 1;
  padding: 0 8px;
}

.toggle-switch .left-label {
  position: absolute;
  left: 40px;
}

.toggle-switch .right-label {
  position: absolute;
  right: 23px;
}
</style>
